<template>
  <v-tab-item :value="$route.path" class="pa-3">
    <v-sheet class="pa-3" outlined style="overflow: auto">
      <v-toolbar flat height="90">
        <v-row class="d-flex">
          <v-col class="pa-0 mt-3">
            <ExportLinks export-key="company-redeemed-gifts" />
          </v-col>

          <v-col cols="12" sm="6" class="pa-0 d-flex">
            <b-select
              :items="statuses"
              :item-text="`name[${lang}]`"
              item-value="value"
              v-model="status"
              :label="translations.status[lang]"
              class="mr-6"
            ></b-select>

            <b-select
              :items="suppliers"
              item-text="name"
              item-value="supplier_store_id"
              v-model="supplierId"
              :label="translations.supplier[lang]"
              class="mr-6"
            ></b-select>
          </v-col>

          <v-col sm="3">
            <b-search-field v-model="search"></b-search-field>
          </v-col>
        </v-row>
      </v-toolbar>

      <b-data-table
        :headers="headers"
        :items="gifts"
        :page.sync="page"
        @page-sync="(p) => (page = p)"
        class="b-outlined"
      >
        <template v-slot:no-data>
          {{ translations.noData[lang] }}
        </template>
        <template v-slot:item.order_code="{ item }">
          {{ item.order_code }}
        </template>

        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:item.invoice_url="{ item }">
          <a :href="item.invoice_url" target="_blank" v-if="item.invoice_url">
            {{ item.invoice_url }}
          </a>
          <span v-else>-</span>
        </template>
      </b-data-table>
    </v-sheet>
  </v-tab-item>
</template>

<script>
import {
  mdiFormatListCheckbox,
  mdiMicrosoftExcel,
  mdiFileDelimitedOutline,
  mdiMagnify,
  mdiChevronDown,
} from '@mdi/js';
import { mapMutations, mapState, mapActions } from 'vuex';
import ExportLinks from '@/components/general/ExportLinks.vue';
import translations from '@/utils/translations/loyaltyPanel/redemptions';
import moment from 'moment';
import debounce from 'lodash/debounce';

export default {
  name: 'Products',

  mixins: [translations],

  components: {
    ExportLinks,
  },

  data() {
    return {
      icons: {
        mdiFormatListCheckbox,
        mdiMicrosoftExcel,
        mdiFileDelimitedOutline,
        mdiMagnify,
        mdiChevronDown,
      },
      menu: false,
      selectedSearchType: 'All Fields',
      supplierId: null,
      statuses: [
        {
          name: {
            el: 'Στάλθηκε στον προμηθευτή',
            en: 'Sent to supplier',
            it: 'Inviato al fornitore',
          },
          value: 6,
        },
        {
          name: {
            el: 'Στάλθηκε απο τον προμηθευτή στον πελάτη',
            en: 'Sent from supplier to costumer',
            it: 'Inviato dal fornitore al cliente',
          },
          value: 7,
        },
      ],
      status: null,
      page: +this.$route.query.page,
      search: '',
    };
  },

  computed: {
    ...mapState('loyaltyPanel/redemptions', ['gifts', 'suppliers']),
    ...mapState(['loading', 'serverItemsLength']),

    lang() {
      return this.$route.params.lang;
    },

    headers() {
      return [
        {
          text: this.translations.statusName[this.lang],
          value: 'transaction_status_name',
          width: 150,
        },
        {
          text: this.translations.mobile[this.lang],
          value: 'user_mobile',
          width: 150,
        },
        {
          text: this.translations.supplierName[this.lang],
          value: 'store_supplier_name',
          width: 150,
        },
        {
          text: this.translations.giftTitle[this.lang],
          value: 'gift_title',
          width: 150,
        },
        // {
        //     text: this.translations.giftDescription[this.lang],
        //     value: "gift_description",
        // },
        {
          text: this.translations.orderCode[this.lang],
          value: 'order_code',
          width: 150,
        },
        {
          text: this.translations.date[this.lang],
          value: 'created_at',
          width: 150,
        },
        {
          text: this.translations.supplierInvoice[this.lang],
          value: 'invoice_url',
          width: 150,
        },
      ];
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/redemptions', ['fetchRedemptions', 'getSuppliers']),

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },

    handleSearch() {
      const body = {
        status: this.status,
        supplier_id: this.supplierId,
        page: this.page,
        query: this.search,
      };
      this.fetchRedemptions(body);
    },
  },

  mounted() {
    const body = {
      status: this.status,
      supplier_id: this.supplierId,
      page: this.page,
      query: this.search,
    };
    this.fetchRedemptions(body);
    this.getSuppliers();
  },

  watch: {
    supplierId(val) {
      const body = {
        status: this.status,
        supplier_id: val,
        page: this.page,
        query: this.search,
      };
      this.fetchRedemptions(body);
    },

    status(val) {
      const body = {
        status: val,
        supplier_id: this.supplierId,
        page: this.page,
        query: this.search,
      };
      this.fetchRedemptions(body);
    },

    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      const body = {
        status: this.status,
        supplier_id: this.supplierId,
        page: this.page,
        query: this.search,
      };
      this.fetchRedemptions(body);
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

    search(val) {
      if (val == null) {
        const body = {
          status: this.status,
          supplier_id: this.supplierId,
          page: this.page,
          query: this.search,
        };
        this.fetchRedemptions(body);
      } else {
        this.page = 1;
        this.debouncedSearch();
      }
    },
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },
};
</script>
